import { render, staticRenderFns } from "./vertical-timeline.vue?vue&type=template&id=5c65deea&scoped=true&"
import script from "./vertical-timeline.vue?vue&type=script&lang=js&"
export * from "./vertical-timeline.vue?vue&type=script&lang=js&"
import style0 from "./vertical-timeline.vue?vue&type=style&index=0&id=5c65deea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65deea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
